import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const BankDetailsSkeleton = () => {
    return (
        <>
            {Array(3)
                .fill().map((_, index) =>
                    <div className="valign-wrapper space-between" style={{ padding: "1rem" }}>
                        <span className="valign-wrapper gap-1">
                            <Skeleton circle height={24} width={24} />
                            <div>
                                <span className="valign-wrapper" style={{ gap: "5px" }}>
                                    <Skeleton width={150} height={20} />
                                    <Skeleton width={20} height={20} />
                                </span>
                                <p className="grey-text" style={{ marginTop: "-5px", fontSize: "14px" }}>
                                    <Skeleton width={80} height={14} />
                                </p>
                            </div>
                        </span>
                        <Skeleton circle height={24} width={24} />
                    </div>)}

        </>
    );
};

export default BankDetailsSkeleton;
